import { render } from "./ParseOffer.vue?vue&type=template&id=5637210c&scoped=true"
import script from "./ParseOffer.vue?vue&type=script&lang=js"
export * from "./ParseOffer.vue?vue&type=script&lang=js"

import "./ParseOffer.vue?vue&type=style&index=0&id=5637210c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5637210c"]])

export default __exports__